import { BlogArticleCard } from "../../components/blog/BlogArticleCard";
import type { BlogArticleGridComponent } from "../../types";
import { RuntimeLink } from "../../runtime/RendererRuntime";
import { resolveLinkHref } from "../../utils/links";

/** Blog article grid renderer with pagination and CTA button. */
export function BlogArticleGridRenderer({ component }: { component: BlogArticleGridComponent }) {
  const { items, ctaHref, ctaLabel } = component.content;
  const resolvedCtaHref = resolveLinkHref(ctaHref);
  const nextPageHref = resolvedCtaHref ?? "/blog?page=2";
  return (
    <section>
      {resolvedCtaHref && ctaLabel ? (
        <div className="mt-2 mb-6 md:mb-8">
          <RuntimeLink href={resolvedCtaHref} className="rounded-full bg-[#FFC105] px-3 py-1.5 text-sm xl:text-base font-semibold text-white hover:opacity-90">{ctaLabel}</RuntimeLink>
        </div>
      ) : null}
      <div className="grid gap-4 sm:gap-6 md:grid-cols-3">
        {items.map((a, idx) => (
          <BlogArticleCard key={`${a.title}-${idx}`} category={a.category} title={a.title} excerpt={a.excerpt} author={a.author} authorRole={a.authorRole} date={a.date} href={a.href} />
        ))}
      </div>
      <nav className="mt-8 flex items-center justify-center gap-3" aria-label="Pagination">
        <span className="inline-flex h-8 items-center rounded-md bg-[#00B862] px-2 text-white text-sm xl:text-base font-semibold">1</span>
        <span className="text-sm xl:text-base text-slate-700">sur 10</span>
        <RuntimeLink href={nextPageHref} className="inline-flex items-center gap-2 rounded-md bg-[#00B862] px-4 py-2 text-sm xl:text-base font-semibold text-white hover:bg-[#0087cf]">
          suivant <span aria-hidden className="text-base xl:text-lg leading-none">›</span>
        </RuntimeLink>
      </nav>
    </section>
  );
}


